/** @module csi/widget/_svg/ImageReset */
define([
	"dijit/form/Button",
	"csi/locale",
	"./_Plugin",
	"./PluginFactory",
	"./util"
], function(Button,locale,_Plugin,PluginFactory,util) {

	return PluginFactory.declare([Button,_Plugin], {
		"class": "canvasImageResetButton",
		label: "CanvasResetImage",
		pluginName: "ImageReset",

		/**
		 * Only allow if this is edit mode for selected shape
		 */
		enablePlugin: function(shapes, shapeAttrs, textAttrs) {
			this.set('checked', false);
			
			return this.editor.shapesArePictures(shapes, true);
		},

		/**
		 * Edit selected page object.
		 */
		onClick: function() {
			this.editor.scaleImageToFrame("reset");
		}
	});
});
